/* GLORY DEPT. — gd-utils.js
   Shared: scroll reveal, image fade-in, email capture success state. */
(function () {
  'use strict';

  function reveal() {
    var els = document.querySelectorAll('.gd-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function imageFade() {
    document.querySelectorAll('.gd-section img').forEach(function (img) {
      if (img.complete) { img.classList.add('gd-loaded'); }
      else { img.addEventListener('load', function () { img.classList.add('gd-loaded'); }, { once: true }); }
      img.addEventListener('error', function () { img.classList.add('gd-loaded'); }, { once: true });
    });
  }

  function email() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      document.querySelectorAll('.gd-email').forEach(function (sec) {
        var ok = sec.querySelector('[data-gd-email-success]');
        var form = sec.querySelector('.gd-email__form');
        if (ok) ok.hidden = false;
        if (form) form.setAttribute('hidden', 'hidden');
      });
    }
    document.querySelectorAll('.gd-email__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[type="email"]');
        if (input && input.value) {
          // Klaviyo hook: window.klaviyo && window.klaviyo.push(['identify', { '$email': input.value }]);
          document.dispatchEvent(new CustomEvent('gd:email-submit', { detail: { email: input.value, list: form.dataset.klaviyoList || null } }));
        }
      });
    });
  }

  function init() { reveal(); imageFade(); email(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
